// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3924d","left":"styles_left__3NMZz"};